export function truncateString(value: string, maxLength: number): string {
    return value.length > maxLength
        ? value.slice(0, maxLength) + ' ...'
        : value;
}
